// ASL State Nodes
import { TaskNode } from './TaskNode';
import { ChoiceNode } from './ChoiceNode';
import { PassNode } from './PassNode';
import { WaitNode } from './WaitNode';
import { ParallelNode } from './ParallelNode';
import { MapNode } from './MapNode';
import { MapContainerNode } from './MapContainerNode';
import { SucceedNode } from './SucceedNode';
import { FailNode } from './FailNode';

// Control Flow Nodes
import { ParallelJoinNode } from './ParallelJoinNode';
import { MergeNode } from './MergeNode';

// UI Marker Nodes
import { StartMarkerNode } from './StartMarkerNode';

// Legacy nodes (kept for backward compatibility)
import { FanOutNode } from './FanOutNode';
import { FanInNode } from './FanInNode';

/**
 * Node type registry for ReactFlow.
 * 
 * ASL State Types:
 * - task, choice, pass, wait, parallel, map, succeed, fail
 * 
 * Control Flow:
 * - parallelJoin: Parallel join bar (synchronization)
 * - merge: Structural convergence of alternative paths (NOT synchronization)
 * - mapContainer: Container for Map iterator states (visual grouping)
 * 
 * UI Markers:
 * - startMarker: Shows StartAt pointer
 * 
 * Legacy (deprecated):
 * - fanOut, fanIn: Old parallel visualization
 */
export const nodeTypes = {
    // ASL State Types
    task: TaskNode,
    choice: ChoiceNode,
    pass: PassNode,
    wait: WaitNode,
    parallel: ParallelNode,
    map: MapNode,
    succeed: SucceedNode,
    fail: FailNode,

    // Control Flow Types
    parallelFork: FanOutNode,
    parallelJoin: ParallelJoinNode,
    merge: MergeNode,
    mapContainer: MapContainerNode,

    // UI Markers
    startMarker: StartMarkerNode,

    // Legacy (backward compatibility)
    fanOut: FanOutNode,
    fanIn: FanInNode,
};

// ASL State Nodes
export { TaskNode, ChoiceNode, PassNode, WaitNode, ParallelNode, MapNode, MapContainerNode, SucceedNode, FailNode };

// Control Flow Nodes
export { ParallelJoinNode, MergeNode };

// UI Marker Nodes
export { StartMarkerNode };

// Legacy (deprecated)
export { FanOutNode, FanInNode };

